import {
  ContextMenuContent,
  ContextMenuItem
} from "@/components/ui/context-menu";

import Bold from "../toolbar-buttons/bold";
import Italic from "../toolbar-buttons/italic";
import Strikethrough from "../toolbar-buttons/strikethrough";
import Underline from "../toolbar-buttons/underline";
import ButtonContextActions from "./button-actions";
import ChartContextActions from "./chart-actions";
import IconContextActions from "./icon-actions";
import ImageContextActions from "./image-actions";
import InputContextMenuActions from "./input-actions";
import LinkContextActions from "./link-actions";
import SelectContextActions from "./select-actions";
import ShapeContextActions from "./shape-actions";
import TableContextAction from "./table-actions";

const ToolbarContextMenu: React.FC<
  React.ComponentProps<"div"> & {
    editorRef: React.RefObject<HTMLDivElement>;
    rightClickedElement: HTMLElement | null;
  }
> = ({ editorRef, rightClickedElement }) => {
  const shapeContainer = rightClickedElement?.dataset?.shapeContainer
    ? rightClickedElement
    : (rightClickedElement?.closest("[data-shape-container]") ?? null);

  const shapeElement = rightClickedElement?.dataset?.shape
    ? rightClickedElement
    : (rightClickedElement?.closest("[data-shape]") ?? null);

  const resolvedShapeTarget = (shapeContainer ||
    shapeElement) as HTMLElement | null;

  const resolvedChartTarget =
    rightClickedElement?.dataset?.type === "chart"
      ? rightClickedElement
      : ((rightClickedElement?.closest('[data-type="chart"]') ||
          rightClickedElement
            ?.closest(".recharts-wrapper")
            ?.closest('[contenteditable="false"]')) as HTMLElement | null);

  const resolvedImageTarget =
    rightClickedElement?.dataset?.type === "image"
      ? rightClickedElement
      : (rightClickedElement?.closest(
          '[data-type="image"]'
        ) as HTMLElement | null);

  const resolvedLinkTarget = rightClickedElement?.tagName === "A"
    ? rightClickedElement
    : (rightClickedElement?.closest("a") as HTMLElement | null);

  return (
    <ContextMenuContent>
      {resolvedShapeTarget ? (
        <ShapeContextActions
          editorRef={editorRef}
          rightClickedElement={resolvedShapeTarget}
        />
      ) : resolvedChartTarget ? (
        <ChartContextActions rightClickedElement={resolvedChartTarget} />
      ) : resolvedImageTarget ? (
        <ImageContextActions rightClickedElement={resolvedImageTarget} />
      ) : resolvedLinkTarget ? (
        <LinkContextActions rightClickedElement={resolvedLinkTarget} />
      ) : (
        (() => {
          switch (rightClickedElement?.tagName.toUpperCase()) {
            case "INPUT":
              return (
                <InputContextMenuActions
                  editorRef={editorRef}
                  rightClickedElement={rightClickedElement}
                />
              );
            case "TEXTAREA":
              return (
                <InputContextMenuActions
                  editorRef={editorRef}
                  rightClickedElement={rightClickedElement}
                />
              );
            case "SELECT":
              return (
                <SelectContextActions
                  editorRef={editorRef}
                  rightClickedElement={rightClickedElement}
                />
              );

            case "I":
              return (
                <IconContextActions rightClickedElement={rightClickedElement} />
              );
            case "TABLE":
              return (
                <TableContextAction
                  editorRef={editorRef}
                  rightClickedElement={rightClickedElement}
                />
              );
            case "BUTTON":
              return (
                <ButtonContextActions
                  rightClickedElement={rightClickedElement}
                />
              );
            case "IMG":
              return (
                <ImageContextActions
                  rightClickedElement={rightClickedElement}
                />
              );

            default:
              return (
                <ContextMenuItem className="focus:bg-transparent">
                  <div className="flex gap-x-2">
                    <Bold editorRef={editorRef} />
                    <Italic editorRef={editorRef} />
                    <Underline editorRef={editorRef} />
                    <Strikethrough editorRef={editorRef} />
                  </div>
                </ContextMenuItem>
              );
          }
        })()
      )}
    </ContextMenuContent>
  );
};

export default ToolbarContextMenu;
